<script>
	import API from '../States/API';
	import Collector from '../Models/Scripture/Collector';
	import Data from '../States/Data';
	import Helper from '../Models/Helper';
	import Session from '../States/Session';
	import Slider from '../States/Slider';
	import Trigger from '../Models/Trigger';

	export let index = 0;

	let properties = {};
	let content = {};
	let favorites = [];
	let verses = [];
	let results = [];
	let expand = [];
	let active = false;

	async function init() {
		Helper.title('Favorieten');
		load();
	}

	async function load() {
		const response = await API.favorites();
		favorites = response.bookmarks;
		verses = favoriteVerses(favorites);
		collect();
	}

	async function collect() {
		const collector = new Collector();
		let structure = await collector.collect(verses, expand);
		structure = favoriteStructure(structure, favorites);
		results = structure;
	}

	function favoriteVerses(favorites) {
		const verses = [];
		if (Array.isArray(favorites))
			favorites.forEach(favorite => {
				verses.push(favorite.verse);
			});

		return verses;
	}

	function favoriteStructure(structure, favorites) {
		const favorite = code => {
			for (const favorite of favorites)
				if (favorite.verse === code)
					return favorite;
		};

		if (Array.isArray(structure))
			structure.forEach(book => book.verses.forEach(verse => {
				verse.favorite = favorite(verse.info.code);
			}));

		return structure;
	}

	function verseTotal(results) {
		let total = 0;
		for (const book of results)
			total += book.verses.length;

		return total;
	}

	function expandBook(book) {
		expand.push(book);
		collect();
	}

	function toBook(book) {
		const code = book.code;
		const base = jQuery(content);
		const selector = `#favorite_result_${code}`;
		const element = base.find(selector);
		if (element.length) {
			let top = element.offset().top - base.offset().top + base.scrollTop();
			top -= 75;
			base.animate({scrollTop: top}, 1000 * .5);
		}
	}

	function toReference(verse) {
		verse.reference.proceed = true;
		Slider.route(['reference', [verse.reference, 2, 1]])
		jQuery('div.item[data-verse]').removeClass('active');
		jQuery(`div.item[data-verse="${verse.info.code}"]`).addClass('active');
	}

	function updateSlider(slides) {
		active = Slider.check(index, 'favorite', properties);
		if (active) {
			properties = Slider.properties(index);
			active = properties.active;
		}
	}

	async function edit(item) {
		if (Helper.onlineNotice()) {
			const verse = item.favorite.verse;
			const note = item.favorite.textarea.value;
			const response = await API.updateFavorite({verse, note});
			if (response.success) {
				load();
				const message = 'Jouw notitie is toegevoegd.';
				Trigger.event('alert', {icon: 'check-circle', message});
			}

			else {
				const message = 'Jouw notitie kan niet toegevoegd worden.';
				Trigger.event('alert', {icon: 'exclamation-triangle', message});
			}
		}
	}

	async function remove(item) {
		if (Helper.onlineNotice()) {
			const verse = item.favorite.verse;
			const response = await API.deleteFavorite({verse});
			if (response.success) {
				load();
				const message = 'Het favoriete vers is verwijderd.';
				Trigger.event('alert', {icon: 'check-circle', message});
			}

			else {
				const message = 'Het favoriete vers kan niet verwijderd worden.';
				Trigger.event('alert', {icon: 'exclamation-triangle', message});
			}
		}
	}

	init();
	Slider.subscribe(updateSlider);
</script>

<style>
	div.favorite-notice {
		margin-bottom: 3em;
	}

	h3.list.books,
	div.list.books {
		color: var(--tertiary-color);
	}

	div.list.books > .item > div.percentage {
		background: var(--tertiary-background-light);
	}

	div.list.books > .item div.name i {
		margin-right: .5em;
		opacity: .5;
	}

	div.results h3.solid.list {
		margin-top: 2em;
	}

	div.results div.list {
		margin-bottom: 1.5em;
	}

	div.results div.list > .item {
		font-weight: 400;
		margin: .75em 0;
		padding-bottom: .5em;
		cursor: auto;
	}

	div.results div.list > .item > p {
		font-size: 1.1em;
		line-height: 1.5em;
		padding: .25em 0 .75em 0;
		margin: 0;
		border-bottom: 1px solid var(--primary-background-light);
		cursor: pointer;
	}

	div.results div.list > .item > p strong {
		display: block;
		font-size: .925em;
		color: var(--primary-color);
		margin-bottom: .25em;
	}

	div.results div.list > .item > p strong i {
		font-size: .95em;
		margin-right: .25em;
		opacity: .5;
	}

	div.results div.list > .item > i {
		position: relative;
		margin-top: 1em;
		color: var(--secondary-color);
		float: right;
		right: auto;
	}

	div.results div.list > .item > div {
		font-weight: 700;
		color: var(--secondary-color);
		margin-top: .5em;
	}

	div.results h3 {
		margin: 0;
	}

	div.toolbar > div {
		display: inline-block;
		margin-right: 1.5em;
	}

	div.toolbar > div.icon {
		cursor: pointer;
	}

	div.toolbar > div.icon i {
		margin-right: .5em;
	}

	div.note {
		display: block;
	}

	div.note-content {
		color: var(--box-color);
		background: var(--box-feature-background);
		padding: .5em 1em;
		border-radius: .3em;
	}

	div.note-content i {
		margin-right: .5em;
		opacity: .5;
	}

	div.edit div.title {
		text-transform: uppercase;
		font-size: .9em;
	}

	div.edit textarea {
		font-weight: normal;
		color: var(--box-color);
	}

	div.button.expand {
		margin-top: .75em;
		text-align: left;
		text-transform: none;
		color: var(--tertiary-color);
	}

	:global(div.box.favorite div.results span.highlight) {
		font-weight: 700;
		color: var(--tertiary-color);
	}

	@media (max-device-width: 768px) {
		div.toolbar > div {
			margin-right: .75em;
		}
	}
</style>

<div class="box feature favorite" class:active>
	<div class="menu">
		<div class="begin">
			<div class="title">Favorieten</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content" bind:this="{content}">
		<h1>Favorieten</h1>
		<p>Favorieten maken het handig snel iets in de Bijbel terug te vinden.</p>
		<div class="notice favorite-notice">
			{#if Helper.is(results)}
				<i class="fad fa-info-circle"></i> Je hebt <span>{verseTotal(results)}</span> favoriete bijbel verzen.
			{:else}
				<i class="fad fa-info-circle"></i> Je hebt nog geen favoriete bijbel verzen. Klik op een vers-nummer om een vers als favoriet te bewaren.
			{/if}
		</div>
		{#if Helper.is(results)}
			<h3 class="solid list books">Boeken</h3>
			<div class="solid list books">
				{#each results as book}
					<div class="item" on:click="{event => toBook(book.info.book)}">
						<div class="percentage" style="width: calc({book.percentage}% - .6em);"></div>
						<i class="fad fa-chevron-down"></i>
						<div class="name">
							<i class="fad fa-book"></i> {book.info.book.name}
						</div>
					</div>
				{/each}
			</div>
			<div class="results">
				{#each results as book}
					<h3 id="favorite_result_{book.info.book.code}" class="solid list">
						<a href="/{book.info.book.uri}/1">{book.info.book.name}</a>
					</h3>
					{#if !book.partial}
						<div class="solid list">
							{#each book.verses as verse}
								<div class="item" data-verse="{verse.info.code}">
									<p on:click="{event => toReference(verse)}">
										<strong>
											<i class="fad fa-book-heart"></i> {verse.info.verse.name}
										</strong>
										{@html verse.scripture}
									</p>
									<div class="note">
										{#if verse.favorite.edit}
											<div class="edit">
												<div class="title">Notitie</div>
												<textarea bind:this="{verse.favorite.textarea}" placeholder="Jouw notitie...">{verse.favorite.note}</textarea>
											</div>
										{:else if verse.favorite.note}
											<div class="note-content">
												<i class="fad fa-comment-alt"></i> {verse.favorite.note}
											</div>
										{/if}
									</div>
									{#if $API.active}
										<div class="toolbar">
											{#if !verse.favorite.remove}
												{#if verse.favorite.edit}
													<div class="icon" style="color: var(--success-color);" on:click="{event => edit(verse)}">
														<i class="fad fa-check"></i>
														<span>Opslaan</span>
													</div>
													<div class="icon" style="color: var(--error-color);" on:click="{event => verse.favorite.edit = false}">
														<i class="fad fa-times"></i>
														<span>Annuleren</span>
													</div>
												{:else}
													<div class="icon" on:click="{event => verse.favorite.edit = true}">
														<i class="fad fa-comment-alt-edit"></i>
														<span>{verse.favorite.note ? 'Bewerken' : 'Notitie'}</span>
													</div>
												{/if}
											{/if}
											{#if !verse.favorite.edit}
												{#if verse.favorite.remove}
													<div class="icon" style="color: var(--success-color);" on:click="{event => remove(verse)}">
														<i class="fad fa-check"></i>
														<span>Ik weet het zeker!</span>
													</div>
													<div class="icon" style="color: var(--error-color);" on:click="{event => verse.favorite.remove = false}">
														<i class="fad fa-times"></i>
														<span>Nee, niet verwijderen</span>
													</div>
												{:else}
													<div class="icon" on:click="{event => verse.favorite.remove = true}">
														<i class="fad fa-trash-alt"></i>
														<span>Vers verwijderen</span>
													</div>
												{/if}
											{/if}
										</div>
									{/if}
									<i class="fad fa-chevron-right"></i>
								</div>
							{/each}
						</div>
					{:else}
						<div class="button expand" on:click="{event => expandBook(book.info.book.code)}">
							<i class="fad fa-info-circle"></i> {book.verses.length} favorieten in <span>{book.info.book.name}</span> tonen <i class="fas fa-chevron-down"></i>
						</div>
					{/if}
				{/each}
			</div>
		{/if}
	</div>
</div>